import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './TriggerDesktopAppOpenPage.css';

const OpenAppButton = () => {
  const { t } = useTranslation();

  return (
    <a href="electric-desktop://mdm" id="open-desktop-app-btn">
      {t('triggerOpen.openButton')}
    </a>
  );
};

const TriggerDesktopAppOpenPage = () => {
  const { t } = useTranslation();

  // Redirect user to electric-desktop://mdm when the page loads
  useEffect(() => {
    window.location.href = 'electric-desktop://mdm';
  });

  return (
    <div className="app-div">
      <div className="app-text-container">
        <img
          alt={t('triggerOpen.imageAlt')}
          src="/assets/images/appDownload.svg"
        />
        <h1 className="app-h1 app-text">{t('triggerOpen.title')}</h1>
        <p className="app-p app-text">{t('triggerOpen.description')}</p>
        <div className="open-app-button">
          <OpenAppButton />
        </div>
        <p className="app-p app-text">
          {t('triggerOpen.noApp')}{' '}
          <a href="/app">{t('triggerOpen.downloadLink')}</a>
        </p>
      </div>
    </div>
  );
};

export default TriggerDesktopAppOpenPage;
